import BackofficeImportsBase from './BackofficeImportsBase';

export default class BackofficeMondayImportsIndex extends BackofficeImportsBase {
    constructor() {
        super({
            // Checkbox selectors
            checkboxSelector: '[data-monday-checkbox]',
            checkboxAllSelector: '[data-monday-checkbox-all]',
            
            // Bulk actions selectors
            bulkActionsContainerSelector: '[data-bulk-actions-container]',
            selectedCountSelector: '[data-selected-count]',
            bulkValidateSelector: '[data-bulk-validate]',
            bulkInvalidateSelector: '[data-bulk-invalidate]',
            bulkDeleteSelector: '[data-bulk-delete]',
            bulkArchiveSelector: '[data-bulk-archive]',
            bulkUnarchiveSelector: '[data-bulk-unarchive]',
            
            // Retry import selectors
            retryImportButtonSelector: '[data-retry-import]',
            retryImportModalId: 'retryImportModal',
            fileInputId: 'csv_file',
            confirmCheckboxId: 'confirm_import',
            confirmRetryButtonSelector: '[data-confirm-retry-import]',
            
            // URLs
            bulkValidateUrl: '/monday_imports/bulk_validate',
            bulkInvalidateUrl: '/monday_imports/bulk_invalidate',
            bulkDestroyUrl: '/monday_imports/bulk_destroy',
            bulkArchiveUrl: '/monday_imports/bulk_archive',
            bulkUnarchiveUrl: '/monday_imports/bulk_unarchive',
            retryImportUrl: '/monday_imports/retry_import',
            
            // Item configuration
            itemIdParamName: 'order_ids[]',
            itemName: 'commande',
            itemNamePlural: 'commande(s)'
        });
    }
}
